<template>
    <div class="form-group">
        <label class="label">{{ $t("To Convert") }}</label>
        <div class="col-12 row p-0">
            <div class="col-6 p-0">
                <app-input 
                   :placeholder="$t('Select unit')"
                    type="advance-search-select"
                    fetch-url="/units/serverside/selectable-name"
                    listValueField="code"
                    v-model="internalValue.unit"
                    :loaded-per-time="5"
                    :required="true"
                    @input="updateValue"
                    :disabled="is_view"
                />
            </div>
           
            <div class="col-6 p-0">
                <app-input 
                    type="text"
                    v-model="displayValue"
                    :placeholder="'Value'"
                    :required="true"
                    @input="updateValue"
                    :disabled="true"
                />
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'ToConvert',
    props: {
        value: {
            type: Object,
            default: () => ({
                unit : {id:'', code:'', factor:''},
                value: '',
            })
        },
        is_view : {
            type : Boolean, 
            default : false,
        }
    },
    data() {
        return {
            internalValue: { ...this.value }
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        }
    },
    computed: {
        displayValue: {
            get() {
                const val = this.internalValue.value;
                if (val === null || val === undefined || val === '') return '$ 0.000';
                
                // Usamos Intl.NumberFormat para manejar millones y decimales
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 3,
                    maximumFractionDigits: 3
                }).format(val);
            },
            set(newValue) {
                let cleanValue = String(newValue).replace(/[^0-9.]/g, '');
                let numericValue = parseFloat(cleanValue);
                this.internalValue.value = isNaN(numericValue) ? 0 : numericValue;
                this.updateValue();
            }
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        }
    },
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    /* Quitamos paddings laterales de la fila interna para alinear con el label */
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>